module.exports = __webpack_public_path__ + "static/media/estateEmbraconMobile.1a0fcf20.jpg";